<template>
  <div class="terms-gate">
    <div class="terms-card">
      <div class="terms-logo">MemoFast</div>
      <h1 class="terms-title">Conditions d'utilisation (Beta)</h1>
      <p class="terms-subtitle">
        Avant d'utiliser l'application, vous devez accepter les CGU.
      </p>
      <p class="terms-links">
        <router-link to="/cgu">Lire les CGU</router-link>
        <span class="terms-links-sep">·</span>
        <router-link to="/confidentialite">Confidentialite</router-link>
        <span class="terms-links-sep">·</span>
        <router-link to="/mentions-legales">Mentions legales</router-link>
        <span class="terms-links-sep">·</span>
        <router-link to="/cookies">Cookies</router-link>
      </p>

      <div class="terms-box">
        <h2>Statut Beta</h2>
        <ul>
          <li>Le service est fourni "en l'etat".</li>
          <li>Des bugs / indisponibilites peuvent survenir.</li>
          <li>Des fonctionnalites peuvent changer sans preavis.</li>
          <li>
            Le service est propose gratuitement pendant la periode de Beta.
            Le service peut evoluer (notamment vers une offre payante), apres information prealable des utilisateurs.
          </li>
        </ul>

        <h2>Donnees</h2>
        <ul>
          <li>Vous restez responsable des contenus que vous ajoutez.</li>
          <li>Des donnees techniques peuvent etre journalisees pour securite et debug.</li>
        </ul>

        <p class="terms-meta">
          Version: <strong>{{ currentVersion }}</strong>
        </p>
      </div>

      <label class="terms-check">
        <input type="checkbox" v-model="checked" />
        <span>J'ai lu et j'accepte les conditions d'utilisation (CGU).</span>
      </label>

      <button
        class="terms-btn"
        :disabled="!checked || submitting"
        @click="accept"
      >
        {{ submitting ? 'Validation...' : "J'accepte" }}
      </button>

      <p v-if="error" class="terms-error">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { acceptTerms } from '@/services/termsApi'

export default {
  name: 'TermsGate',
  props: {
    currentVersion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      checked: false,
      submitting: false,
      error: null
    }
  },
  methods: {
    async accept () {
      this.error = null
      this.submitting = true
      try {
        await acceptTerms()
        this.$emit('accepted')
      } catch (e) {
        this.error = "Impossible d'enregistrer l'acceptation. Reessayez."
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.terms-gate {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-lg);
  background: linear-gradient(180deg, var(--color-primary-light) 0%, var(--color-background) 100%);
}

.terms-card {
  width: 100%;
  max-width: 760px;
  background: var(--color-surface);
  border-radius: var(--r-xl);
  padding: var(--space-xl) var(--space-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border-light);
  text-align: left;
}

.terms-logo {
  font-family: var(--font-family-logo);
  font-size: var(--font-size-3xl);
  color: var(--color-primary);
  text-align: center;
  margin-bottom: var(--space-sm);
}

.terms-title {
  font-size: 1.4rem;
  margin: 0 0 var(--space-xs);
  text-align: center;
}

.terms-subtitle {
  margin: 0 0 var(--space-base);
  color: var(--color-text-secondary);
  text-align: center;
}

.terms-links {
  margin: -8px 0 var(--space-base);
  color: var(--color-text-secondary);
  text-align: center;
  font-weight: 600;
}

.terms-links a {
  color: var(--color-primary);
  text-decoration: none;
}

.terms-links a:hover {
  text-decoration: underline;
}

.terms-links-sep {
  margin: 0 8px;
  color: var(--color-text-tertiary);
}

.terms-box {
  border: 1px solid var(--color-border-light);
  border-radius: var(--r-lg);
  background: var(--color-background);
  padding: var(--space-base);
  margin-bottom: var(--space-base);
}

.terms-box h2 {
  font-size: 1rem;
  margin: var(--space-xs) 0;
}

.terms-box ul {
  margin: 0 0 var(--space-sm);
  padding-left: 1.2rem;
}

.terms-meta {
  margin: 0;
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

.terms-check {
  display: flex;
  gap: 0.6rem;
  align-items: flex-start;
  margin: var(--space-base) 0;
  user-select: none;
}

.terms-btn {
  width: 100%;
  border: none;
  border-radius: var(--r-lg);
  padding: 0.9rem 1rem;
  background: var(--color-primary);
  color: var(--color-text-inverse);
  font-weight: 700;
}

.terms-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.terms-error {
  margin-top: var(--space-sm);
  color: var(--color-danger);
  font-weight: 600;
}
</style>
